import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import config from './config';

export enum ANALYTIC_EVENTS {
  // Personal events
  SIGNED_IN = 'User Signed In',
  SIGNED_OUT = 'User Signed Out',
  SIGNED_UP = 'User Signed Up',

  // Group/Organisational events
  ACCOUNT_CREATED = 'Account Created',
  ACCOUNT_DELETED = 'Account Deleted',
  ACCOUNT_ADDED_USER = 'Account Added User',
  ACCOUNT_REMOVED_USER = 'Account Removed User',

  // We also manage "Trial Started" and "Trial "
}

/**
 * Track analytics using Segment script loaded from CDN ()
 * @returns Analytics functional component
 */
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    (analytics as any)._writeKey = config.segmentWriteKey;
    analytics.load(config.segmentWriteKey);
  }, []);

  useEffect(() => {
    analytics.page();
  }, [location.pathname]);

  return <></>;
};

export default Analytics;
